import "./facilityCreateScreen.scss";
import {ITimelineItem} from "../../../shared/models/timeline.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {useNavigate, useSearchParams} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig} from "../../../constants";
import Grid from "@mui/material/Grid";
import TimelineComponent from "../../../shared/components/timeline/timelineComponent";
import FacilityDetailsAddComponent from "./facility-details-add/facilityDetailsAddComponent";
import PhysicianDetailsAddComponent from "./physician-details-add/physicianDetailsAddComponent";
import AdminDetailsAddComponent from "./admin-details-add/adminDetailsAddComponent";
import PrimaryContactDetailsAddComponent from "./primary-contact-details-add/primaryContactDetailsAddComponent";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import UserDetailsAddComponent from "./user-details-add/UserDetailsAddComponent";

interface FacilityCreateScreenComponentProps {

}

const FACILITY_DETAILS = 'facility_details';
const PRIMARY_CONTACT = 'primary_contact';
const PROVIDER_OR_PHYSICIAN = 'Provider_or_Physician';
const ADMIN_DETAILS = "admin_details";
const USER_DETAILS = "user_details";

const STEPS: ITimelineItem[] = [
    {
        id: FACILITY_DETAILS,
        title: "Facility Details",
    },
    {
        id: ADMIN_DETAILS,
        title: "Admin Details",
    },
    {
        id: USER_DETAILS,
        title: "User Details"
    },
    {
        id: PRIMARY_CONTACT,
        title: "Primary Contact",
    },
    {
        id: PROVIDER_OR_PHYSICIAN,
        title: "Provider/Physician",
    },
];


const FacilityCreateScreenComponent = (props: FacilityCreateScreenComponentProps) => {

    const [steps] = useState<ITimelineItem[]>([..._.cloneDeep(STEPS)]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState<ITimelineItem | undefined>(STEPS[0]);
    const [facilityId, setFacilityId] = useState<number | undefined>(undefined);
    const [activeStep, setActiveStep] = React.useState(0);
    const [facilityDetails, setFacilityDetails] = useState<any>(undefined);
    const [isFacilityDetailsLoading, setIsFacilityDetailsLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("", "Facility"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const updateSteps = useCallback((currentStepIndex: number) => {
        setCurrentStep(STEPS[currentStepIndex]);
        searchParams.set("step", STEPS[currentStepIndex].id);
        setSearchParams(searchParams);
        setActiveStep(currentStepIndex);
    }, [searchParams, setSearchParams]);

    const getFacilityDetails = useCallback(() => {
        const payload = {};
        let facilityDetails: any = {};
        setIsFacilityDetailsLoading(true);
        CommonService._facility.getFacilityDetails(facilityId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    facilityDetails = response.data;
                }
                setFacilityDetails(facilityDetails);
                setIsFacilityDetailsLoading(false);
            })
            .catch((error: any) => {
                // setFacilityDetails(facilityDetails);
                setIsFacilityDetailsLoading(false);
            });
    }, [facilityId]);

    const handleFacilityCancel = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: 'Are you sure you want to exit without adding this facility?',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Exit",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.FacilityListRoute());
        }).catch(() => {
            // do nothing;
        });
    }, [navigate]);

    const handleADDSuccess = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Congratulations!',
            confirmationSubTitle: 'Facility has been successfully created.',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.CongratulationImage}`,
            direction: "up",
            hideNoOption: true,
            yes: {
                text: "Proceed",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.FacilityListRoute());
        })
            .catch(() => {
            });
    }, [navigate]);


    const handleNext = useCallback((currentStepIndex: number, currentStepId: string, facilityId?: number, data?: any) => {

        if (parseInt(searchParams.get("lastCompletedStep") || "1") <= currentStepIndex) {
            searchParams.set("lastCompletedStep", currentStepIndex.toString());
            setSearchParams(searchParams);
        }
        console.log("this the actual data", {data, currentStepId})
        switch (currentStepId) {
            case FACILITY_DETAILS :
                if (facilityId) {
                    setFacilityId(facilityId);
                    searchParams.set("facilityId", facilityId.toString());
                    setSearchParams(searchParams);
                }
                if (data) {
                    setFacilityDetails((oldSate: any) => {
                        const tempObj = {
                            ...oldSate,
                            addressDetails: data.addressDetails,
                            name: data.name,
                            type: data.type,
                            id: data.id,
                            code: data.code,
                            isActive: data.isActive,
                        }
                        return tempObj;
                    })
                }
                updateSteps(currentStepIndex);
                break;
            case ADMIN_DETAILS:
                if (data) {
                    setFacilityDetails((oldSate: any) => {
                        return {
                            ...oldSate,
                            ...data
                        }
                    })
                }
                updateSteps(currentStepIndex);
                break;
            case USER_DETAILS:
                if (data) {
                    setFacilityDetails((oldSate: any) => {
                        return {
                            ...oldSate,
                            userDetails: data
                        }
                    })
                }
                updateSteps(currentStepIndex);
                break;
            case PRIMARY_CONTACT:
                if (data) {
                    setFacilityDetails((oldSate: any) => {
                        return {
                            ...oldSate,
                            primaryContactDetails: data
                        }
                    })
                }
                updateSteps(currentStepIndex);
                break;
            case PROVIDER_OR_PHYSICIAN:
                handleADDSuccess();
                break;
            default:
                <></>
        }
    }, [searchParams, setSearchParams, updateSteps, handleADDSuccess]);

    useEffect(() => {
        const step = searchParams.get("step");
        setActiveStep(STEPS.findIndex((stepItem: any) => stepItem.id === step));
        const facilityId = searchParams.get("facilityId");
        const stepIDS = STEPS.map(item => item.id);
        let stepIndex = 0;
        if (facilityId) {
            setFacilityId(parseInt(facilityId, 10));
            if (stepIDS.indexOf(step) > -1) {
                stepIndex = stepIDS.indexOf(step);
            } else {
                stepIndex = 1;
            }
        } else {
            stepIndex = 0;
            setActiveStep(0)
        }
        setCurrentStep(STEPS[stepIndex]);
    }, [searchParams]);

    const handlePrevious = useCallback((currentStepIndex: number, currentStepId: string) => {
        updateSteps(currentStepIndex);
    }, [updateSteps]);

    const renderComponent = useCallback(() => {
        if (!facilityId) {
            if (currentStep?.id === FACILITY_DETAILS) {
                return <FacilityDetailsAddComponent
                    next={(facilityId: number) => handleNext(1, FACILITY_DETAILS, facilityId)}
                    cancel={handleFacilityCancel}
                />
            }
        } else {
            switch (currentStep && currentStep.id) {
                case FACILITY_DETAILS:
                    return <FacilityDetailsAddComponent
                        next={(facilityId: number, data: any) => handleNext(1, FACILITY_DETAILS, facilityId, data)}
                        facilityDetails={facilityDetails}
                        cancel={handleFacilityCancel}
                    />
                case ADMIN_DETAILS:
                    return <AdminDetailsAddComponent
                        facilityId={facilityId}
                        facilityDetails={facilityDetails}
                        cancel={handleFacilityCancel}
                        next={(data: number) => handleNext(2, ADMIN_DETAILS, undefined, data)}
                        prev={() => handlePrevious(0, ADMIN_DETAILS)}
                    />
                case USER_DETAILS:
                    return <UserDetailsAddComponent
                        facilityId={facilityId}
                        facilityDetails={facilityDetails}
                        cancel={handleFacilityCancel}
                        next={(data: any) => handleNext(3, USER_DETAILS, undefined, data)}
                        prev={() => handlePrevious(1, USER_DETAILS)}
                    />
                case PRIMARY_CONTACT:
                    return <PrimaryContactDetailsAddComponent
                        facilityId={facilityId}
                        facilityDetails={facilityDetails}
                        cancel={handleFacilityCancel}
                        prev={() => handlePrevious(2, PRIMARY_CONTACT)}
                        next={(data: number) => handleNext(4, PRIMARY_CONTACT, undefined, data)}
                    />
                case PROVIDER_OR_PHYSICIAN:
                    return <PhysicianDetailsAddComponent
                        facilityId={facilityId}
                        cancel={handleFacilityCancel}
                        next={() => handleNext(5, PROVIDER_OR_PHYSICIAN, undefined)}
                        prev={() => handlePrevious(3, PROVIDER_OR_PHYSICIAN)}
                    />
                default:
                    <></>
            }
        }
    }, [facilityId, currentStep, handleNext, handleFacilityCancel, handlePrevious, facilityDetails]);


    useEffect(() => {
        if (facilityId) {
            getFacilityDetails();
        }
    }, [facilityId, getFacilityDetails]);

    const handleStepClick = useCallback((step: any) => {
        const lastCompletedStep = parseInt(searchParams.get("lastCompletedStep") || '0');
        const clickedStepIndex = STEPS.findIndex((stepItem: any) => stepItem.id === step.id);
        if (clickedStepIndex <= (lastCompletedStep)) {
            setActiveStep(clickedStepIndex);
            setCurrentStep(step);
            searchParams.set("step", step.id);
            setSearchParams(searchParams);
        }
    }, [searchParams, setSearchParams]);

    return (
        <div className="facility-creation-layout-screen add-layout-with-timeline screen ">
            <Grid container spacing={2} className="add-form-timeline-wrapper">
                <Grid item sm={12} md={3} xl={3} className="timeline-layout"
                      sx={{
                          display: {xs: "none", md: "block"}
                      }}>
                    <div className="add-layout-title">Adding Facility</div>
                    <div className="add-layout-timeline">
                        <TimelineComponent
                            activeStep={activeStep}
                            steps={steps}
                            lastCompletedStep={parseInt(searchParams.get("lastCompletedStep") || '0')}
                            handleStepClick={handleStepClick}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={9} xl={9} className="add-form-content">
                    <div className="add-layout-form-content">
                        {renderComponent()}
                    </div>
                </Grid>
            </Grid>
            {isFacilityDetailsLoading &&
                <div className={"glass-effect h-v-center flex-direction-column"}>
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
        </div>
    )

};

export default FacilityCreateScreenComponent;
